import moment from "moment";
import t from "./translate";

export const formatTimeAgoFr = (timestamp) => {
  if (!timestamp) return "";

  const created = moment(timestamp);
  if (!created.isValid()) return "";

  const now = moment();
  const diffSec = now.diff(created, "seconds");

  if (diffSec < 60) return t("just_now");

  const diffMin = now.diff(created, "minutes");
  if (diffMin < 60) {
    return diffMin === 1 ? t("minute_ago") : t("minutes_ago", { count: diffMin });
  }

  const diffHour = now.diff(created, "hours");
  if (diffHour < 24) {
    return diffHour === 1 ? t("hour_ago") : t("hours_ago", { count: diffHour });
  }

  const diffDay = now.diff(created, "days");
  if (diffDay < 7) {
    return diffDay === 1 ? t("day_ago", { count: 1 }) : t("days_ago", { count: diffDay });
  }

  const diffMonth = now.diff(created, "months");
  if (diffMonth >= 12) {
    const diffYear = now.diff(created, "years");
    return diffYear === 1 ? t("year_ago", { count: 1 }) : t("years_ago", { count: diffYear });
  }

  if (diffMonth >= 1) {
    return diffMonth === 1 ? t("month_ago", { count: 1 }) : t("months_ago", { count: diffMonth });
  }

  const diffWeek = now.diff(created, "weeks");
  return diffWeek === 1 ? t("week_ago") : t("weeks_ago", { count: diffWeek });
};
